import styled, { css } from 'styled-components';
import { grey400, white, greenLight, chartOrange } from 'styles/colors';
import ReactTooltip from 'react-tooltip';

export const IconWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	color: ${grey400};
	cursor: pointer;
	color: ${props => {
		if (props.active) return white;
		return props.open ? greenLight : grey400;
	}};
	transition: color 100ms ease-out;
	&:hover {
		color: ${props => (props.active ? white : greenLight)};
	}

	${({ hasData, active }) =>
		hasData &&
		!active &&
		css`
			&:after {
				content: '';
				display: inline-block;
				width: 14px;
				height: 14px;
				border-radius: 7px;
				border: 2px solid ${white};
				background-color: ${chartOrange};
				right: 4px;
				top: 6px;
				position: absolute;
			}
		`};
`;

export const StyledReactTooltip = styled(ReactTooltip)`
	opacity: initial !important;
	box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);
	padding: 0;
	border-radius: initial;

	&:after {
		left: initial !important;
		right: 15px;
	}
`;
